import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import { withFormik, Field } from 'formik';
import * as yup from 'yup';
import MaskedInput from 'react-maskedinput';
import classnames from 'classnames';

import InputFeedback from '../InputFeedback';
import Warranty from '../Warranty';
import { format } from 'url';

import ReactPixel from 'react-facebook-pixel';

const PaymentSchema = yup.object().shape({
  ccnumber: yup
    .string()
    .matches(/^\d{4} \d{4} \d{4} \d+(\d{1,4}|\ {1,})$/, {
      message: 'Card number is not valid',
      excludeEmptyString: true,
    })
    .required("Card number can't be empty"),
  exp_month: yup
    .string()
    .matches(/^(0?[1-9]|1[012])$/, {
      message: 'Expiration month is not valid',
      excludeEmptyString: true,
    })
    .required("Expiration month can't be empty"),
  exp_year: yup
    .string()
    .matches(/^\d{2}$/, {
      message: 'Expiration year is not valid',
      excludeEmptyString: true,
    })
    .test({
      name: 'exp_year',
      test: value => parseInt(value, 10) >= new Date().getFullYear() - 2000,
      message: `Should be greater or equal to ${new Date().getFullYear() -
        2000}`,
    })
    .required("Expiration year can't be empty"),
  cvv2: yup
    .string()
    .matches(/^\d{3,}(\d+|)$/, {
      message: 'CVC is not valid',
      excludeEmptyString: true,
    })
    .required("CVC can't be empty"),
});

class BillingForm extends Component {
  render() {
    const {
      isSubmitting,
      handleSubmit,
      isValid,
      values,
      cost,
      initialValues,
      errors,
      coupon,
      source_from,
    } = this.props;
    return (
      <Fragment>
        <div className="profile-modal__descr billing-container">
          <div className="profile-card__fields">
            <div className="profile-card__fields-title">
              Enter your payment details
            </div>
            <div className="position-relative form-group">
              <div className="form-group__top">
                <label htmlFor="frmCCNum" className="form-group__label">
                  Card number
                </label>
              </div>
              <Field
                name="ccnumber"
                render={({ field }) => (
                  <MaskedInput
                    type="text"
                    id="frmCCNum"
                    className="form-input input-border form-control middle"
                    mask="1111 1111 1111 1111"
                    placeholderChar=" "
                    placeholder="XXXX XXXX XXXX XXXX"
                    size="19"
                    autoComplete="cc-number"
                    {...field}
                  />
                )}
              />
              <InputFeedback
                error={
                  values.ccnumber !== initialValues.ccnumber && errors.ccnumber
                }
              />
            </div>
            <div className="b-row">
              <div className="b-col-4">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="cc-exp-month" className="form-group__label">
                      Expiration month
                    </label>
                  </div>
                  <Field
                    name="exp_month"
                    render={({ field }) => (
                      <MaskedInput
                        id="cc-exp-month"
                        className="form-input input-border form-control middle"
                        mask="11"
                        placeholder="05"
                        placeholderChar=" "
                        autoComplete="cc-exp-month"
                        size="2"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={
                      values.exp_month !== initialValues.exp_month &&
                      errors.exp_month
                    }
                  />
                </div>
              </div>
              <div className="b-col-4">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="cc-exp-year" className="form-group__label">
                      Expiration year
                    </label>
                  </div>
                  <Field
                    name="exp_year"
                    render={({ field }) => (
                      <MaskedInput
                        id="cc-exp-year"
                        className="form-input input-border form-control middle"
                        mask="11"
                        placeholderChar=" "
                        placeholder="25"
                        size="2"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={
                      values.exp_year !== initialValues.exp_year &&
                      errors.exp_year
                    }
                  />
                </div>
              </div>
              <div className="b-col-4">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="cvv2" className="form-group__label">
                      CVC
                    </label>
                  </div>
                  <Field
                    name="cvv2"
                    render={({ field }) => (
                      <input
                        type="text"
                        id="cvv2"
                        className="form-input input-border form-control middle"
                        placeholder="***"
                        size="4"
                        maxLength="4"
                        autoComplete="cc-csc"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={values.cvv2 !== initialValues.cvv2 && errors.cvv2}
                  />
                </div>
              </div>
            </div>
            <div className="separator-line bottom" />
            <div className="b-row">
              <div className="b-col-6">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="first_name" className="form-group__label">
                      First name
                    </label>
                  </div>
                  <Field
                    name="first_name"
                    render={({ field }) => (
                      <input
                        type="text"
                        id="first_name"
                        className="form-input input-border form-control middle"
                        placeholder=""
                        autoComplete="name"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={
                      values.first_name !== initialValues.first_name &&
                      errors.first_name
                    }
                  />
                </div>
              </div>
              <div className="b-col-6">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="last_name" className="form-group__label">
                      Last name
                    </label>
                  </div>
                  <Field
                    name="last_name"
                    render={({ field }) => (
                      <input
                        type="text"
                        id="last_name"
                        className="form-input input-border form-control middle"
                        placeholder=""
                        autoComplete="name"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={
                      values.last_name !== initialValues.last_name &&
                      errors.last_name
                    }
                  />
                </div>
              </div>
            </div>
            <div className="b-row">
              <div className="b-col-8">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="country" className="form-group__label">
                      Billing country
                    </label>
                  </div>
                  <Field
                    name="country"
                    render={({ field }) => (
                      <input
                        type="text"
                        id="country"
                        className="form-input input-border form-control middle"
                        autoComplete="country"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={
                      values.country !== initialValues.country && errors.country
                    }
                  />
                </div>
              </div>
              <div className="b-col-4">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="zip" className="form-group__label">
                      ZIP code
                    </label>
                  </div>
                  <Field
                    name="zip"
                    render={({ field }) => (
                      <input
                        type="text"
                        id="zip"
                        className="form-input input-border form-control middle"
                        autoComplete="zipcode"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={values.zip !== initialValues.zip && errors.zip}
                  />
                </div>
              </div>
              <div className="b-col-12">
                <div className="position-relative form-group">
                  <div className="form-group__top">
                    <label htmlFor="country" className="form-group__label">
                      Billing address
                    </label>
                  </div>
                  <Field
                    name="address"
                    render={({ field }) => (
                      <input
                        type="text"
                        id="adress"
                        className="form-input input-border form-control middle"
                        autoComplete="address"
                        {...field}
                      />
                    )}
                  />
                  <InputFeedback
                    error={
                      values.address !== initialValues.address && errors.address
                    }
                  />
                </div>
              </div>
            </div>
            <div className="profile-card__fields-title">
              <strong>Do you have coupon? Apply it!</strong>
            </div>
            <div className="b-row">
              <div className="b-col-12">
                <div className="position-relative form-group">
                  {(source_from.source === 'from_upgrade_now') ?
                    (<Field
                      name="coupon"
                      render={({ field }) => (
                        <input
                          type="text"
                          id="coupon"
                          className="form-input input-border form-control middle"
                          autoComplete="coupon"
                          placeholder="Enter your coupon code"
                          {...field}
                          value={coupon}
                        />
                      )}
                    />) : (
                      <Field
                        name="coupon"
                        render={({ field }) => (
                            <input
                              type="text"
                              id="coupon"
                              className="form-input input-border form-control middle"
                              autoComplete="coupon"
                              placeholder="Enter your coupon code"
                              {...field}
                            />)}
                        />
                      )}
                </div>
              </div>
            </div>
            <div className="separator-line" />
            <Warranty />
            <div className="profile-card__divider" />
            <div className="total-sum__row">
              <span className="total-sum__caption">Subscription total</span>
              <span className="billing-sum__value">${cost}</span>
            </div>
            <div className="text-center profile-card__submit">
              <Button
                color="blue"
                className="full-width p-r-2 p-l-2 m-r-15"
                onClick={handleSubmit}
                disabled={!isValid || isSubmitting}>
                {isSubmitting ? 'Loading' : 'Subscribe'}
              </Button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withFormik({
  mapPropsToValues: () => ({
    ccnumber: '',
    exp_month: '',
    exp_year: '',
    cvv2: '',
    plan: 'annually',
  }),
  isInitialValid: false,
  validateOnBlur: false,
  validationSchema: PaymentSchema,
  handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
    await props.handleSubmit(values, setSubmitting, setErrors);
    ReactPixel.track('SubmitApplication');
  },
})(BillingForm);



// WEBPACK FOOTER //
// ./src/components/BillingForm/BillingForm.js